import { render, staticRenderFns } from "./featured-card.vue?vue&type=template&id=38272ec5&scoped=true&lang=pug&"
import script from "./featured-card.vue?vue&type=script&lang=js&"
export * from "./featured-card.vue?vue&type=script&lang=js&"
import style0 from "./featured-card.vue?vue&type=style&index=0&id=38272ec5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38272ec5",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsImage: require('/home/ubuntu/nuxt/bonkers/releases/20230925165443/components/widgets/image.vue').default})
